import { Befehl22FormData, Befehl22FormSchema } from './schema'
import { Befehl22 } from '../../../models'
import { BefehlAuftrag_22_10Dto } from '../../../dtos'
import {
  Befehl22DataDto,
  Feld_22_11Dto,
  Feld_22_12Dto
} from '../../../dtos/befehl-22-dto'
import { Betriebsstellenart } from '../../../types'
import {
  createField,
  filterNullFields,
  findAuftragByKennung
} from '../converter-utils'

export const convertModelToBefehl22FormData = (
  befehl?: Befehl22
): Befehl22FormData => {
  const formData = Befehl22FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  const auftrag22_10 = findAuftragByKennung(
    befehl.auftraege,
    '22.10'
  ) as BefehlAuftrag_22_10Dto

  const feld22_11 = auftrag22_10?.felder?.find(
    (feld) => feld.kennung === '22.11'
  ) as Feld_22_11Dto

  const feld22_12 = auftrag22_10?.felder?.find(
    (feld) => feld.kennung === '22.12'
  ) as Feld_22_12Dto

  if (auftrag22_10) {
    if (feld22_11?.werte && 'bf' in feld22_11.werte) {
      formData.auftrag22_10.selector = Betriebsstellenart.Bf
      formData.auftrag22_10.name = feld22_11.werte.bf || ''
    } else if (feld22_12?.werte && 'bft' in feld22_12.werte) {
      formData.auftrag22_10.selector = Betriebsstellenart.Bft
      formData.auftrag22_10.name = feld22_12.werte.bft || ''
    }
  }

  return formData
}

export const convertBefehl22FormDataToModel = (
  formData: Befehl22FormData,
  frontendId: string
): Befehl22 => {
  const auftraege: Befehl22DataDto = []

  if (formData.auftrag22_10?.enabled) {
    const { selector, name } = formData.auftrag22_10 || {}

    const fields = filterNullFields([
      selector === Betriebsstellenart.Bf
        ? createField('22.11', { bf: name || '' })
        : null,
      selector === Betriebsstellenart.Bft
        ? createField('22.12', { bft: name || '' })
        : null
    ])

    auftraege.push({
      kennung: '22.10',
      felder: fields as (Feld_22_11Dto | Feld_22_12Dto)[]
    })
  }

  return {
    kennung: '22',
    frontendId,
    auftraege
  }
}
